import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.connector.DOC}
  mutation UpdateIntegrationConnector(
    $tenantId: ID!
    $zoneId: ID!
    $id: ID!
    $updates: IntgConnectorUpdates!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        updateIntgConnector(id: $id, updates: $updates) {
          ...FragmentIntegrationConnector
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.UpdateIntegrationConnectorMutation,
    ents.core.integrations.Connector,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'updateIntgConnector',
        fragments.connector.TRANSFORMER,
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.UpdateIntegrationConnectorMutation,
  ents.core.integrations.Connector,
  graphql.schema.UpdateIntegrationConnectorMutationVariables
>({ query: DOC, transformer: TRANSFORMER })
